import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { afterItems, beforeItems } from '../data/transformation';
export function ComparisonSection() {
  return <section aria-labelledby="comparison-title" className="bg-white px-4 py-20 md:py-28" data-id="element-42" data-mp="39d6fzrg84hec">
      <Reveal className="mx-auto max-w-6xl" data-id="element-43" data-mp="34ev295mt5mqu">
        <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-44" data-mp="2zglal50al49z">
          <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal-ink" data-id="element-45" data-mp="2zhwd71i045zi">
            MOINS DE RECHERCHE, PLUS DE REPÈRES
          </p>
          <h2 id="comparison-title" className="text-3xl font-extrabold leading-tight tracking-tight text-brand-navy md:text-4xl" data-id="element-46" data-mp="2qf3mazcqdwa7">
            Tout préparer seul, ou partir d’une base structurée.
          </h2>
        </div>
        <div className="overflow-hidden rounded-3xl border border-brand-line bg-white shadow-xl shadow-brand-navy/5" data-id="element-47" data-mp="om5wzdi5xlu0">
          <div className="grid md:grid-cols-2" data-id="element-48" data-mp="3afcp63mhkos3">
            <Comparison eyebrow="TOUT PRÉPARER SEUL" title="AVANT" items={beforeItems} positive={false} data-id="element-49" data-mp="3adjjornm0alo" />
            <Comparison eyebrow="UNE BASE STRUCTURÉE" title="AVEC MUSIQUE PRÊTE" items={afterItems} positive data-id="element-50" data-mp="3ei11ilaesdtt" />
          </div>
          <div className="border-t border-brand-line bg-brand-ivory px-6 py-4 text-center text-xs italic text-slate-600" data-id="element-51" data-mp="35gjlt40wye5n">
            Choisissez vos ressources, adaptez-les à votre groupe et concentrez-vous sur la séance.
          </div>
        </div>
        <div className="mt-10 flex justify-center" data-id="element-52" data-mp="3jg2mjbrean7x">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-53" data-mp="3jfj13l2jdgp5" />
        </div>
      </Reveal>
    </section>;
}
interface ComparisonProps {
  eyebrow: string;
  title: string;
  items: string[];
  positive: boolean;
}
function Comparison({
  eyebrow,
  title,
  items,
  positive
}: ComparisonProps) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'bg-brand-ivory md:border-l md:border-brand-line' : 'bg-slate-100'}`} data-id="element-54" data-mp="ulj0ainstgeb">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-55" data-mp="pmes9vcm1opk">
        <div data-id="element-56" data-mp="knles2xbpxpe">
          <p className={`text-[10px] font-extrabold uppercase tracking-[0.16em] ${positive ? 'text-brand-teal-ink' : 'text-slate-600'}`} data-id="element-57" data-mp="knbqcjrxfylt">
            {eyebrow}
          </p>
          <h3 className="mt-2 text-xl font-bold tracking-tight text-brand-navy md:text-2xl" data-id="element-58" data-mp="bmnarkmvxq6t">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal-ink text-white shadow-sm' : 'bg-white text-slate-600'}`} data-id="element-59" data-mp="6vx1hwbc936u">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-60" data-mp="3t46gcynmloih" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-61" data-mp="3p1jtzd9q4vso">
        {items.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/70 px-3 py-3" data-id="element-62" data-mp="3p3w97io3ks21">
            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-turquoise/15 text-brand-teal-ink' : 'bg-slate-900/5 text-slate-600'}`} data-id="element-63" data-mp="3k4th0yt7ugbh">
              <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-64" data-mp="28lcpei672qgh" />
            </span>
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-slate-800' : 'text-slate-600'}`} data-id="element-65" data-mp="28j9txim9w54d">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}